<template>
  <div class="popup-overlay" @click="closePopup">
    <div class="popup-content" @click.stop>
      <div class="popup-body">
        <div class="image-container">
          <img
            src="@/assets/Atenção.gif"
            alt="Instruções de edição"
            class="instruction-image"
            draggable="false"
            @contextmenu.prevent
            @dragstart.prevent
          />
        </div>

        <div class="button-container">
          <button class="continue-button" @click="continuarEditando">
            Continuar editando
          </button>
          <button class="confirm-button" @click="confirmar">
            Confirmar e continuar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopupConfirmacao",
  methods: {
    closePopup() {
      this.$emit("close");
    },
    continuarEditando() {
      this.$emit("close");
    },
    confirmar() {
      this.$emit("confirmado");
    },
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.popup-content {
  background: white;
  border-radius: 12px;
  padding: 0;
  max-width: 95vw;
  max-height: 95vh;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.popup-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.instruction-image {
  max-width: 600px;
  max-height: 900px;
  width: 100%;
  height: auto;
  border-radius: 12px 12px 0 0;
  display: block;
}

.button-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
}

.continue-button {
  background: #f5f5f5;
  color: #333;
  border: 2px solid #ddd;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
}

.continue-button:hover {
  background: #e8e8e8;
  border-color: #ccc;
}

.confirm-button {
  background: linear-gradient(135deg, #ff6b9d, #c44569);
  color: white;
  border: none;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
}

.confirm-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 107, 157, 0.4);
}

/* Responsivo para mobile */
@media (max-width: 768px) {
  .popup-content {
    margin: 20px;
    max-width: calc(100vw - 40px);
  }

  .button-container {
    padding: 20px;
  }

  .continue-button,
  .confirm-button {
    padding: 14px 20px;
    font-size: 16px;
  }
}
</style>
